export default "__VITE_ASSET__sQXDkfKI__"